import { useEffect, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { fetchGiveawayByShort } from "../api/client.js";

function readTelegramStartappParam(searchParams) {
  const fromQuery =
    searchParams.get("startapp") || searchParams.get("tgWebAppStartParam") || "";
  if (fromQuery) return fromQuery;
  try {
    return String(window.Telegram?.WebApp?.initDataUnsafe?.start_param || "").trim();
  } catch {
    return "";
  }
}

function giveawayBasePath(giveawayId) {
  return `/giveaway/${giveawayId}`;
}

function isOnGiveawayRoute(pathname, giveawayId) {
  const base = giveawayBasePath(giveawayId);
  return pathname === base || pathname.startsWith(`${base}/`);
}

/** Deep link: ?startapp=g_<id> или ?startapp=s_<shortCode> */
export default function TelegramGiveawayDeepLink() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const handledStartappRef = useRef("");

  useEffect(() => {
    const startapp = readTelegramStartappParam(params);
    if (!startapp) return;

    if (startapp.startsWith("g_")) {
      const id = startapp.slice(2);
      if (!id) return;
      if (isOnGiveawayRoute(location.pathname, id)) {
        handledStartappRef.current = startapp;
        return;
      }
      if (handledStartappRef.current === startapp) return;
      handledStartappRef.current = startapp;
      navigate(giveawayBasePath(id), { replace: true });
      return;
    }

    if (startapp.startsWith("s_")) {
      const code = startapp.slice(2);
      if (!code) return;
      const marker = `s_${code}`;
      if (handledStartappRef.current === marker) return;

      let cancelled = false;
      (async () => {
        try {
          const g = await fetchGiveawayByShort(code);
          if (cancelled || !g?.id) return;
          if (isOnGiveawayRoute(location.pathname, g.id)) {
            handledStartappRef.current = marker;
            return;
          }
          handledStartappRef.current = marker;
          navigate(giveawayBasePath(g.id), { replace: true });
        } catch {
          /* ignore */
        }
      })();
      return () => {
        cancelled = true;
      };
    }
  }, [params, navigate, location.pathname]);

  return null;
}
